const snakeToCamel = function (string) {
  return string.replace(/(\_[a-z])/g, ($1) => $1.toUpperCase().replace('_', ''));
};

const camelToSnack = function (string) {
  return string.replace(/([A-Z])/g, ($1) => '_' + $1.toLowerCase());
};

const serialize = function (obj: any, fn: Function, clone: any = {}) {
  const deepClone = JSON.parse(JSON.stringify(obj));

  for (const key in deepClone) {
    if (deepClone.hasOwnProperty(key)) {
      if (deepClone[key] instanceof Object) {
        deepClone[key] = serialize(deepClone[key], fn);
      }

      if ((typeof deepClone[key]) === 'string') {
        clone[fn(key)] = removeDollars(deepClone[key]);
      } else {
        clone[fn(key)] = deepClone[key];
      }
    }
  }

  return clone;
};

const removeDollars = function (value: string) {
  if (value.length > 1 && value.charAt(0) === '$' && value.charAt(value.length - 1) === '$') {
    if (value.length < 3) {
      return '';
    } else {
      return value.substring(1, value.length - 1);
    }
  }

  return value;
};

export const Serialize = {
  snakeToCamel: function (obj: any) {
    return serialize(obj, snakeToCamel);
  },
  camelToSnack: function (obj: any) {
    return serialize(obj, camelToSnack);
  }
};



// WEBPACK FOOTER //
// ./src/app/shared/helpers/serialize.helper.ts